var React = require('react');
var { Heading, Panel, PanelContent, PanelHeader, IconButton } = require('@metro-ui/core');
var { Back } = require('@metro-ui/icons');

class LoginPreferencesCardWrapper extends React.Component {

    constructor(props) {
        super(props);
        this._onBackNavigationClick = this.onBackNavigationClick.bind(this);
    }

    onBackNavigationClick() {
        this.props.onBackNavigationClick();
    }

    render() {
        return (
            <div className="login-preferences-wrapper">
                <Panel className="login-preferences-panel">
                    <PanelHeader padding="medium" className="login-preferences-panel-header">
                        {this.props.showBackNavIcon == true &&
                        <IconButton
                            Icon={Back}
                            hasNoInteractionEffect
                            label="Back"
                            color="metro-blue"
                            onClick={this._onBackNavigationClick}
                        />}
                        <Heading hasNoNativeMargin>
                            {this.props.headingText}
                        </Heading>
                    </PanelHeader>
                    <PanelContent padding={{ l: "x-large", xl: "x-large", m: "x-large", s: "small", xs: "small" }}
                        direction="column"
                        className="login-preferences-panel-content"
                        spacing="x-large">
                        {this.props.children}
                    </PanelContent>
                </Panel>
            </div>
        )
    }
}

module.exports = LoginPreferencesCardWrapper;